export default {"src":"/_next/static/media/plane.8cfb3b92.svg","height":45,"width":41,"blurWidth":0,"blurHeight":0};